import React from 'react';
import cx from 'classnames';
import utils from '../../../lib/utils';
import './index.scss';

const getColor=(sent,total)=>{
  if(total*0.9<sent){
    return '#D47E73'
  }
}
const ProgressBar = ({ role, sent ,total}) => {
  return (
    <div className='progress'>
      {total>0? 
      (
      <>
      <div className="bar">
        <div className="status" style={{width:(sent/total*390),backgroundColor:getColor(sent ,total)}}></div>
      </div>
      <div className="text">
        You've sent <span>{sent.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> out of <span>{total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> message monthly limit
      </div>
      </>
      ):
      (<div><a href="mailto:support@truelark.com">Upgrade to Ultimate</a> to experience powerful personalized outreach. Feature details<a class="video-link" href={window.Config.OUTREACH_CONFIG.SUPPORT_VIDEO}  target="_blank">here.</a></div>)  
      }
    </div>
  );
};
export default ProgressBar;
